import { render, staticRenderFns } from "./ValidationConfirm.vue?vue&type=template&id=477bcc89&scoped=true"
import script from "./ValidationConfirm.vue?vue&type=script&lang=js"
export * from "./ValidationConfirm.vue?vue&type=script&lang=js"
import style0 from "./ValidationConfirm.vue?vue&type=style&index=0&id=477bcc89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477bcc89",
  null
  
)

export default component.exports